<template>
    <CSidebar fixed :minimize="minimize" :show="show"
        @update:show="(value) => $store.commit('set', ['sidebarShow', value])">

        <CSidebarBrand class="d-md-down-none" to="/">
            <!--<img src="/img/logoResp.png" class="c-sidebar-brand-full"/>--><!--:height="40"-->
            <img src="/img/alt60px_logo-gesto.png" :height="54" class="c-sidebar-brand-full" />
            <img src="/img/gesto/logo.png" class="c-sidebar-brand-minimized" size="custom-size" :height="30" />
        </CSidebarBrand>


        <!--<CSidebarNav>
        <CSidebarNavItem>
            <CSidebarNavDropdown name="asdasd" :items="[{name: 'aSd', to: '/base/navbars'}]">
               <CSidebarNavItem name="asd123">
               </CSidebarNavItem>
            </CSidebarNavDropdown>
        </CSidebarNavItem>
        <CSidebarNavItem>
            <CSidebarNavDropdown name="asdasd"  :items="[{name: 'asd2', to: '/base/navbars', icon: 'cil-speedometer'}]">
            </CSidebarNavDropdown>
        </CSidebarNavItem>
    </CSidebarNav>-->
        
        <CargandoInfo :mostrarCarga="isLoadingModulos" :img="'/img/gesto/logo.png'" :heightImg="30" :textColor="'#fff'"
            :textSize="'0.7rem'" :mensajeInfo="minimize?'Obt. Modulos' : 'Obteniendo Módulos...'" />

        <!--<div v-show="isLoadingModulos">
        <center>
            <img src="/img/logo2.png" size="custom-size" :height="30" class="imgr mt-3 mb-3" /> Obteniendo sus Módulos...
        </center>
    </div>-->
        <!--<CSidebarNav>
      <CSidebarNavDropdown name="asd2" icon="cil-puzzle">
      <CSidebarNavTitle class="mt-0" style="font-size: 0.5rem; font-weight: normal;">
        asd
      </CSidebarNavTitle>
        <CSidebarNavItem  name="asd12345" icon="cil-chart-pie" to="asd/asd"></CSidebarNavItem>
      </CSidebarNavDropdown>
    </CSidebarNav>
    -->
        <CRenderFunction v-show="!isLoadingModulos" flat :content-to-render="itemsNav" />


        <!--
    {{ colors }}
    <div style="margin-bottom: 70px;">
    
    <chrome-picker v-model="colors" />

    <material-picker v-model="colors" />
    <compact-picker v-model="colors" />
    <swatches-picker v-model="colors" />
    <slider-picker v-model="colors" />
    <sketch-picker v-model="colors" />
    <photoshop-picker v-model="colors" />
    <hr>
    </div>-->

        <CSidebarMinimizer :style="{ 'color': $store.state.colorSideBar.hex8 }" class="d-md-down-none"
            @click.native="$store.commit('set', ['sidebarMinimize', !minimize])" />
    </CSidebar>
</template>

<script>
//import nav from './_nav'

import cons from '@/const'
import axios from "axios"
import { freeSet } from '@coreui/icons'
import CargandoInfo from '@/views/utils/CargandoInfo'

import { Material, Compact, Swatches, Slider, Sketch, Chrome, Photoshop } from 'vue-color'
import { CSidebar } from '@coreui/vue'

import CryptoJS from "crypto-js";

export default {
    name: 'TheSidebar',
    freeSet,
    components: {
        CargandoInfo,
        'material-picker': Material,
        'compact-picker': Compact,
        'swatches-picker': Swatches,
        'slider-picker': Slider,
        'sketch-picker': Sketch,
        'chrome-picker': Chrome,
        'photoshop-picker': Photoshop
    },
    //nav,
    computed: {
        show() {
            return this.$store.state.sidebarShow
        },
        minimize() {
            return this.$store.state.sidebarMinimize
        }
    },
    data() {
        return {

            tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
            idCliente: JSON.parse(this.$cookie.get('userLogginToken')).idCliente,
            tipoUsuario: JSON.parse(this.$cookie.get('userLogginToken')).tipoUsuario,

            isLoadingModulos: false,

            itemsNav: [],

            colors: localStorage.getItem('color1'),
            modulosHash: null,
        }
    },
    beforeMount() {
        this.getModulos()
        this.$store.state.sidebarMinimize = true;
    },
    methods: {
        getModulos: function () {

            this.isLoadingModulos = true

            var url = cons.port + "://" + cons.ipServer + "/get_modulos/";
            axios({
                method: "POST",
                "url": url,
                "data": {
                    "info": {
                        "idCliente": this.idCliente,
                        "tipoUsuario": this.tipoUsuario,
                    }
                },
                "headers": {
                    'Authorization': `${this.tokenLogin}`,
                }
            }).then(result => {
                this.modulosHash = CryptoJS.MD5(JSON.stringify(result.data)).toString();

                this.itemsNav = [
                    {
                        _name: 'CSidebarNav',
                        _children: result.data
                    }
                ]
                this.isLoadingModulos = false
            }, error => {
                let mensaje = `Problema al obtener modulos, ${error}`
                this.isLoadingModulos = false
            })
                .finally(() => {
                });


        },
    }
}
</script>

<style scoped></style>